import { render, staticRenderFns } from "./AnnouncementDetails.vue?vue&type=template&id=f1d11e6e&scoped=true"
import script from "./AnnouncementDetails.vue?vue&type=script&lang=js"
export * from "./AnnouncementDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementDetails.vue?vue&type=style&index=0&id=f1d11e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d11e6e",
  null
  
)

export default component.exports